"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWeightedAverageConcentrationLimitKickouts = exports.sortReceivables = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const sortReceivables = ({ receivables, limitType, }) => {
    // add secondary sort on ASC 'eligibleExposureLessConcentrationLimitKickouts' as aligned here
    // https://finleytechnologies.slack.com/archives/C02HVEP2AF5/p1668737804540669
    return _.orderBy(receivables, [
        ({ value }) => value,
        ({ eligibleExposureLessConcentrationLimitKickouts }) => eligibleExposureLessConcentrationLimitKickouts,
    ], [limitType === 'max' ? 'desc' : 'asc', 'asc']);
};
exports.sortReceivables = sortReceivables;
/**
 * Greedy algorithm solves by:
 * 1) sorting receivables by concentration limit property (value), then by weight (eligibleExposureLessConcentrationLimitKickouts)
 * 2) discretely removing the largest breaching receivables until weighted average meets concentration limit threshold
 */
const calculateWeightedAverageConcentrationLimitKickouts = ({ receivables, limitType, concentrationLimit, }) => {
    // first sort by the value we want to measure against
    const sortedReceivables = (0, exports.sortReceivables)({ limitType, receivables });
    // make a copy, as we will mutate weightedAverageReceivables length
    // while looping through sortedReceivables
    const weightedAverageReceivables = [...sortedReceivables];
    // remove excess concentration by removing one loan record at a time
    // and checking against new weighted average value
    // since it's sorted, we can exit early once we're in the "clear" of our concentration limit
    const kickouts = {};
    sortedReceivables.every((rec) => {
        const weightedAverage = common_1.utils.calculateWeightedAverage(weightedAverageReceivables, { roundingPrecision: 10 });
        switch (limitType) {
            case 'min': {
                if (weightedAverage >= concentrationLimit) {
                    return false;
                }
                break;
            }
            case 'max':
                if (weightedAverage <= concentrationLimit) {
                    return false;
                }
                break;
            default:
                throw Error(`unknown limitType ${limitType}`);
        }
        kickouts[rec.finleyReceivableId] =
            rec.eligibleExposureLessConcentrationLimitKickouts;
        weightedAverageReceivables.shift();
        // return true only if there are more receivables that can be kicked out.
        // once we kickout everything return false;
        return weightedAverageReceivables.length > 0;
    });
    return kickouts;
};
exports.calculateWeightedAverageConcentrationLimitKickouts = calculateWeightedAverageConcentrationLimitKickouts;
//# sourceMappingURL=greedy.js.map